import React from 'react';

import { MicrositeHeader } from '@latitude/microsite-header';

const APPLY_NOW_URL = '/credit-cards/low-rate#limited-time-offer-selector';

const DATA = [
  {
    id: 'home',
    label: 'Home',
    trackId: 'nav-home',
    href: '/credit-cards/low-rate/'
  },
  {
    id: 'c2p',
    label: 'Click to Pay',
    trackId: 'nav-c2p',
    href: '/click-to-pay/'
  },
  {
    id: 'faqs',
    label: 'FAQs',
    trackId: 'nav-faqs',
    href: '/credit-cards/low-rate/faqs/'
  },
  {
    id: 'help',
    label: 'Help',
    trackId: 'nav-help',
    href: 'https://latitudefs.zendesk.com/hc/en-au/'
  }
];

function LowRateMicrositeHeader({ applyNowUrl = APPLY_NOW_URL }) {
  return (
    <div
      css={`
        background-color: #f8f8f8;

        .microsite-header {
          z-index: 2000 !important;
        }

        div[class^='MicrositeHeader__HeaderPlaceholder'] {
          height: 0;
        }
      `}
    >
      <MicrositeHeader
        data={DATA}
        microSiteName="Low Rate"
        ctaHref={applyNowUrl}
        ctaText='Make a selection'
      />
    </div>
  );
}

export default LowRateMicrositeHeader;
